import { ApiClient, type CursorPagedResponse } from '@/infra/api-client'
import type {
  AcceptLatestTermsRequest,
  ListWorkspaceAcceptancesRequest,
  TermsAcceptanceCheckRequest,
  TermsAcceptanceCheckResponse,
  TermsOfUseAcceptanceResource,
  TermsOfUseDocumentResource,
} from '@/features/account/api/resources/tou'

export class TermsOfUseApi extends ApiClient {
  listWorkspaceAcceptances(
    { workspace_id: workspaceId, ...rest }: ListWorkspaceAcceptancesRequest,
    signal?: AbortSignal,
  ): Promise<CursorPagedResponse<TermsOfUseAcceptanceResource>> {
    const params = ApiClient.createSearchParamsFromPageQuery(rest)
    if (rest.expand) {
      for (const e of rest.expand) {
        params.append('expand[]', e)
      }
    }
    return this._get(`v3/terms-acceptance/${workspaceId}`, params, { signal })
  }

  getLatestTermsOfUseDocument(
    workspaceId: string | null | undefined,
    signal?: AbortSignal,
  ): Promise<TermsOfUseDocumentResource> {
    return this._get(`v3/terms-of-use/${workspaceId ?? ''}`, undefined, {
      signal,
    })
  }

  checkAcceptance(
    request?: TermsAcceptanceCheckRequest,
    signal?: AbortSignal,
  ): Promise<TermsAcceptanceCheckResponse> {
    return this._post(`v3/terms-acceptance`, request, undefined, { signal })
  }

  acceptLatestTerms(
    request: AcceptLatestTermsRequest,
  ): Promise<TermsOfUseAcceptanceResource> {
    return this._post(`v3/terms-acceptance/accept`, request)
  }
}
